import React, { useEffect } from 'react';
import CustomCard, { CustomFilterCard } from '../../../../shared/Cards/CustomCard';
import { useDispatch, useSelector } from 'react-redux';
import ProfileImg from '../../../../assets/icons/camera.png';
import { getImageURL } from '../../../../utils/imageUrl';
import { getCompanyDetail } from '../../../../redux/actions/Settings/Business/companyActions';

const Customization = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getCompanyDetail());
    }, [dispatch]);
    let { company } = useSelector((state) => state?.settings.business);

    const boxStyle = (bgColor) => ({
        width: '30px',
        height: '30px',
        backgroundColor: bgColor,
    });
    return (
        <>
            <CustomFilterCard buttonTitle="Edit Customization" linkTo="/settings/business/customization/edit" />
            <CustomCard col="12" title="Customization">
                <div>
                    <div className="text-sm font-semibold mb-1">App Logo</div>
                    <img
                        src={company?.logo ? (typeof company?.logo === 'string' ? getImageURL(company?.logo) : URL.createObjectURL(company?.logo)) : ProfileImg}
                        alt="logo"
                        style={{ width: '100px' }}
                    />
                    <div className="text-sm font-semibold mb-1">Color Pellets</div>
                    <div className="p-2 surface-card border-round shadow-2 inline-flex">
                        <div className="flex border-round overflow-hidden border-1 border-100">
                            <div style={boxStyle(company?.primaryColor)} />
                            <div style={boxStyle(company?.darkTextColor)} />
                            <div style={boxStyle(company?.secondaryColor)} />
                            <div style={boxStyle(company?.lightTextColor)} />
                        </div>
                    </div>
                </div>
            </CustomCard>
        </>
    );
};

export default Customization;
